import React, { useEffect } from "react";
import OrderTraker from "./OrderTraker";
import StarIcon from "@mui/icons-material/Star";
import { useNavigate, useParams } from "react-router-dom";
import AddressCard from "../adreess/AdreessCard";
import { deepPurple } from "@mui/material/colors";
import { useDispatch, useSelector } from "react-redux";
import { getOrderById } from "../../../Redux/Customers/Order/Action";
import BackdropComponent from "../BackDrop/Backdrop";
import Navbar from "../../../components/Navbar";
import Footer from "../../../components/Footer";

const OrderDetails = () => {
  const dispatch = useDispatch();
  const { orderId } = useParams();
  const { order } = useSelector((store) => store);

  useEffect(() => {
    dispatch(getOrderById(orderId));
  }, [dispatch, orderId]);

  const navigate = useNavigate();

  return (
    <div className="bg-black min-h-screen pt-40 text-white">
      <Navbar />
      {!order.loading && (
        <div className="px-4 lg:px-36 space-y-7">
          <div className="p-3 shadow-lg border border-gray-700 rounded-md">
            <p className="font-bold text-lg py-2">Delivery Address</p>
            <AddressCard address={order.order?.shippingAddress} />
          </div>

          <div className="p-5 shadow-lg border border-gray-700 rounded-md">
            <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center">
              <OrderTraker
                activeStep={
                  order.order?.orderStatus === "PLACED"
                    ? 1
                    : order.order?.orderStatus === "CONFIRMED"
                      ? 2
                      : order.order?.orderStatus === "SHIPPED"
                        ? 3
                        : 5
                }
              />
              <div className="mt-4 lg:mt-0">
                {order.order?.orderStatus === "DELIVERED" ? (
                  <button className="text-red-500 border-none bg-transparent cursor-pointer">
                    RETURN
                  </button>
                ) : (
                  <button className="text-deep-purple-500 border-none bg-transparent cursor-pointer">
                    CANCEL ORDER
                  </button>
                )}
              </div>
            </div>
          </div>

          <div className="space-y-5">
            {order.order?.orderItems.map((item) => (
              <div
                key={item.product._id}
                className="shadow-xl rounded-md p-5 border border-gray-700 flex flex-col sm:flex-row items-center justify-between"
              >
                <div className="flex items-center mb-4 sm:mb-0">
                  <img
                    className="w-20 h-20 object-cover object-top"
                    src={item?.product.imageUrl}
                    alt={item.product.title}
                  />
                  <div className="ml-5 space-y-2">
                    <p className="text-base font-medium">{item.product.title}</p>
                    <p className="opacity-50 text-xs font-semibold space-x-5">
                      <span>Color: pink</span> <span>Size: {item.size}</span>
                    </p>
                    <p className="text-sm">Seller: {item.product.brand}</p>
                    <p className="text-lg font-bold">₹{item.price}</p>
                  </div>
                </div>
                <div
                  className="flex items-center cursor-pointer text-deep-purple-500"
                  onClick={() => navigate(`/account/rate/${item.product._id}`)}
                >
                  <StarIcon sx={{ fontSize: "2rem" }} className="text-5xl" />
                  <span className="ml-2 text-base">Rate & Review Product</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      <BackdropComponent open={order.loading} />
      <Footer />
    </div>
  );
};

export default OrderDetails;
